import { render, staticRenderFns } from "./PostThumb.vue?vue&type=template&id=44da3e02"
import script from "./PostThumb.vue?vue&type=script&lang=js"
export * from "./PostThumb.vue?vue&type=script&lang=js"
import style0 from "./PostThumb.vue?vue&type=style&index=0&id=44da3e02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports